// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileHeader_container__2Teks","separator":"MobileHeader_separator__1GiQP"};